import type { AxiosError } from 'axios'
import {
  type ProblemDetails,
  isProblemDetails
} from '../http-client/http-client-types'
import { globalUtils } from '@gat-ship/utils'

export type ApiError = ProblemDetails | AxiosError

export class ApiResponseError<T> extends Error {
  public apiError: ApiError
  public requestPayload: T
  public traceId: string

  constructor({
    message,
    apiError,
    payload
  }: {
    message: string
    apiError: ApiError
    payload: T
  }) {
    super(message)
    this.traceId = isProblemDetails(apiError)
      ? apiError.traceId
      : globalUtils.functions.uuid()
    this.apiError = apiError
    this.requestPayload = globalUtils.functions.duplicateViaJson(payload)
  }

  public getTitle(): string {
    return isProblemDetails(this.apiError)
      ? this.apiError.title
      : this.apiError.message
  }

  public getErrors(): string[] {
    return isProblemDetails(this.apiError)
      ? this.apiError.errors
        ? Object.values(this.apiError.errors).flat()
        : []
      : [this.getDescription()]
  }

  public getDescription(): string {
    return isProblemDetails(this.apiError)
      ? (this.apiError.detail ?? '')
      : (this.apiError.message ?? '')
  }
}
